'use es6';

import I18n from 'I18n';
import { daysAgo } from 'foundations-components/transitional/utils/SimpleDate';
import { getMinCustomValue } from '../components/revenueAttribution/RevenueAttributionDateRangePicker';
import { useMemo } from 'react';
export default function useAttributionDateRange({
  dateRangeFromProps,
  dateRangeState,
  forExport,
  hasRevenueAttributionAccess,
  hasRevenueAttributionLimitedAccess,
  withoutLimitedDateRangePicker
}) {
  return useMemo(() => {
    if (forExport && hasRevenueAttributionLimitedAccess) {
      const minDate = getMinCustomValue({
        hasRevenueAttributionLimitedAccess: true
      });
      const maxDate = daysAgo(1);
      return {
        rangeType: 'CUSTOM',
        startDate: I18n.moment(minDate).isBefore(dateRangeFromProps.startDate) ? dateRangeFromProps.startDate : I18n.moment(minDate).format('YYYY-MM-DD'),
        endDate: I18n.moment(maxDate).isAfter(dateRangeFromProps.endDate) ? dateRangeFromProps.endDate : I18n.moment(maxDate).format('YYYY-MM-DD')
      };
    }
    if (withoutLimitedDateRangePicker) {
      return dateRangeFromProps;
    }
    return hasRevenueAttributionAccess && !hasRevenueAttributionLimitedAccess ? dateRangeFromProps : dateRangeState;
  }, [dateRangeFromProps, dateRangeState, forExport, hasRevenueAttributionAccess, hasRevenueAttributionLimitedAccess, withoutLimitedDateRangePicker]);
}